import { Component, inject, OnInit } from '@angular/core';
import {
  Router,
  NavigationEnd,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { MatButton } from '@angular/material/button';
import {
  FlexColumnComponent,
  FlexRowComponent,
  GrowDirective,
} from '@apexdesigner/flex-layout';
import { AdElDirective } from '../../directives/ad-el/ad-el.directive';

/**
 * Marketing Layout
 *
 * Layout wrapper for public/unauthenticated pages. Provides its own
 * navigation bar and footer, independent of the authenticated app shell.
 */
@Component({
  selector: 'marketing-layout',
  templateUrl: './marketing-layout.component.html',
  styleUrls: ['./marketing-layout.component.scss'],
  host: { adComp: '' },
  imports: [
    AdElDirective,
    FlexColumnComponent,
    FlexRowComponent,
    GrowDirective,
    MatButton,
    RouterLink,
    RouterOutlet,
  ],
})
export class MarketingLayoutComponent implements OnInit {
  authService = inject(AuthService);

  private router = inject(Router);

  /** Is Login Page */
  isLoginPage!: boolean;

  /** Initialize */ initialize(): void {
    this.isLoginPage = this.isMinimalPage(this.router.url);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLoginPage = this.isMinimalPage(event.urlAfterRedirects);
      }
    });
  }

  /** Is Minimal Page - Check if the current URL is a minimal page (no footer) */
  isMinimalPage(url: string): boolean {
    return (
      url.startsWith('/login') ||
      url.startsWith('/no-account') ||
      url.startsWith('/not-authorized')
    );
  }

  /** Login and redirect to home */
  login(): void {
    this.authService.returnUrl = '/home';
    this.authService.login();
  }

  ngOnInit(): void {
    this.initialize();
  }
}
